export default "__VITE_ASSET__CCj4Q1ZB__"